import idx from 'idx'
import { connect } from 'react-redux'
import {bindActionCreators} from 'redux'
import {isLoggedIn} from 'utils/session'
import {compose, lifecycle, withHandlers, withStateHandlers, mapProps} from 'recompose'

import * as inviteModule from 'modules/invite'
import * as userActions from 'actions/userActions'

export default compose(
  connect(
    (state) => {
      return {
        hasError: idx(state, _ => _.progress.checkToken.hasError) || false,
        hasLoginError: idx(state, _ => _.progress.login.hasError) || false,
        errorMessage: idx(state, _ => _.progress.checkToken.error.message) || null,
        hasSignupError: idx(state, _ => _.progress.createAccount.hasError) || false,
      }
    }, 
    (dispatch) => {
      const actions = {
        ...userActions,
        ...inviteModule,
      }
      return {
        actions: bindActionCreators(actions, dispatch),
      }
    }, 
  ),
  withStateHandlers(
    () => ({
      state: isLoggedIn() ? 'token' : 'signin'
    }),
    {
      toggleSignupForm: state => () => ({
        requiresSignup: !state.requiresSignup
      }),
      changeState: () => state => ({
        state
      })
    }
  ),
  withHandlers({
    acceptInvitation: ({ location, actions }) => () => {
      const token = location.search.replace('?token=', '')

      actions.acceptAdminInvitation(token)
    }
  }),
  withHandlers({
    onLoginSubmit: ({ actions, changeState, acceptInvitation }) => (values) => {
      actions.loginUser(values, () => {
        changeState('token')
        acceptInvitation()
      })
    },
  }),
  // Handlers
  withHandlers({
    onSignupSubmit: ({ actions, onLoginSubmit }) => (values) => {
      actions.createUser(values, () => {
        onLoginSubmit(values)
      })
    },
    checkForSession: ({ acceptInvitation }) => () => {
      if (isLoggedIn()) {
        acceptInvitation()
      }
    } 
  }),
  lifecycle({
    componentDidMount() {
      this.props.checkForSession()
    }
  }),
  mapProps((props) => {
    return props
  })
)



// WEBPACK FOOTER //
// ./src/containers/invitations/AdminInviteVerify/AdminInviteVerify.enhancer.js